module.exports = __webpack_public_path__ + "img/Background image 3.97917e09.jpeg";